var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker-company",style:(_vm.style),on:{"click":_vm.openModal}})}
var staticRenderFns = []

export { render, staticRenderFns }